import { Alert, AlertTitle, Button, Link, Typography, Grid2 as Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";

type Props = {
  isSaved: boolean;
  email: string;
  companyName: string;
  contactLink?: string;
  integration?: string;
  accountNumber?: string;
};

export function ContactAlert(props: Props) {
  const { isSaved, email, companyName, contactLink, integration, accountNumber } = props;

  if (isSaved) {
    const alert = integration
      ? ` is saved in ${integration} as a Contact Person for ${companyName}`
      : ` is saved as a Contact Person for ${companyName}`;

    return (
      <Alert severity="success">
        <AlertTitle>Verified Contact</AlertTitle>
        <Link href={`mailto:${email}`} sx={{ wordBreak: "break-all" }}>
          {email}
        </Link>
        <Typography component="span">{alert}</Typography>
      </Alert>
    );
  }

  return (
    <Alert severity="info">
      <AlertTitle>New Contact?</AlertTitle>
      <Link href={`mailto:${email}`} sx={{ wordBreak: "break-all" }}>
        {email}
      </Link>
      <Typography component="span">{` is not saved as a Contact Person for ${companyName} (account number: ${accountNumber})`}</Typography>
      {!!contactLink && (
        <Grid container justifyContent="flex-end" mt={1}>
          <Button
            variant="contained"
            size="small"
            href={contactLink}
            target="_blank"
            endIcon={<ArrowForwardIcon />}
            sx={{ width: "100px" }}
          >
            Add
          </Button>
        </Grid>
      )}
    </Alert>
  );
}
